import { Event } from '@revolugo/elements-vue3'

import type { IEventBus } from '@revolugo/elements-vue3'
import type { PostHog } from 'posthog-js'

export function useCaptureEvents(eventBus: Ref<IEventBus>): void {
  const { $posthog } = useNuxtApp() as unknown as { $posthog: () => PostHog }

  onMounted(() => {
    for (const event of Object.values(Event)) {
      eventBus.value?.$on(event as Event, () => {
        if ($posthog) {
          const posthog = $posthog()
          posthog.capture(event)
        }
      })
    }
  })
}
